import UniCardHead from "@modules/study/common/uni_card_head";
import {
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { htmlParse, numFormatter } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useAuthActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import { Fragment, useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useRecoilValue } from "recoil";
import styles from "./compare_university.module.scss";

export const CompareUniversity = () => {
  const profileInfo = useRecoilValue(authAtom);
  const authActions = useAuthActions();
  const [compareData, setCompareData] = useState([]);
  const [loading, setLoading] = useState(false);

  //get enroll courses
  const getUniversityList = async () => {
    try {
      setLoading(true);
      const res = await API.get(`/student/compare-university/view`);
      if (res.data) {
        setCompareData(res.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  //Handle University Compare
  const handleUniCompare = async (universityId) => {
    if (profileInfo && profileInfo.userTypeSlug) {
      await API.post(`/student/compare-university`, { universityId }).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            await authActions.getProfile();
            await getUniversityList();
          } else {
            swalError(resp.error);
          }
        }
      );
    }
  };

  //initial data load
  useEffect(() => {
    if (profileInfo) {
      getUniversityList();
    }
  }, []);

  const LoadingComponent = () => {
    return (
      <>
        {new Array(10).fill().map((_, i) => {
          const height = i == 0 ? 350 : 50;
          return (
            <div key={i} style={{ marginBottom: "10px" }}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
              </Grid>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <Fragment>
      <section className={styles.section_hero}>
        <div className="container">
          <div className={styles.wrapper}>
            <h1>Compare University</h1>
          </div>
        </div>
      </section>
      <section className={styles.section_compare}>
        <div className="container">
          {loading ? (
            <LoadingComponent />
          ) : (
            <div className={`${styles.ceompare_wrapper} compare_wrapper`}>
              {compareData && compareData.length === 0 ? (
                <div className={styles.noRecordFound}>
                  <h4>You have no compare universities</h4>
                </div>
              ) : (
                <TableContainer className={styles.compare_table_container}>
                  <Table className={styles.compare_head_table}>
                    <TableBody>
                      <TableRow className={styles.compare_head}>
                        <TableCell
                          className={`${styles.compare_head_row} ${styles.head_row_first}`}
                        >
                          <h3 className={styles.compare_heading}>
                            Compare University’s
                          </h3>
                          <p className={styles.compare_sub_text}>
                            You Can Compare Up To 3 University’s
                          </p>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            item.link = `/study/${item?.countrySlug}/university/${item?.universitySlug}`;
                            return (
                              <TableCell
                                className={styles.compare_head_row}
                                key={`overview${index}`}
                              >
                                <button
                                  className={styles.compare_cross_btn}
                                  onClick={() => {
                                    handleUniCompare(item.universityId);
                                  }}
                                >
                                  <FiX />
                                </button>
                                <UniCardHead data={item} />
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Ranking</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`rank${index}`}
                              >
                                {item?.ranking?.map <= 0 ? (
                                  "N/A"
                                ) : (
                                  <Fragment>
                                    {item?.ranking?.map((ritem, i) => {
                                      return (
                                        <div className={styles.ranking_wrapper}>
                                          <div
                                            className={styles.ranking_company}
                                          >
                                            {ritem.rankingCompanyName}
                                          </div>
                                          {
                                            <div className={styles.rank}>
                                              {ritem.rankFrom
                                                ? `#${ritem.rankFrom}`
                                                : ""}{" "}
                                              {ritem.rankFrom &&
                                              ritem.rankTo &&
                                              parseInt(ritem.rankTo) > 0
                                                ? `- ${ritem.rankTo}`
                                                : parseInt(ritem.rankTo) > 0
                                                ? `# ${ritem.rankTo}`
                                                : ""}
                                            </div>
                                          }
                                        </div>
                                      );
                                    })}
                                  </Fragment>
                                )}
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Application Fee</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`rank${index}`}
                              >
                                {parseInt(item.minApplicationFee) === 0 &&
                                parseInt(item.maxApplicationFee) === 0 ? (
                                  <>N/A</>
                                ) : (
                                  <div>
                                    {item.minApplicationFee
                                      ? `${item.currencySymbol}${item.minApplicationFee}`
                                      : ""}{" "}
                                    {item.minApplicationFee &&
                                    item.maxApplicationFee &&
                                    parseInt(item.maxApplicationFee) > 0
                                      ? `- ${item.currencySymbol}${item.maxApplicationFee}`
                                      : parseInt(item.maxApplicationFee) > 0
                                      ? `${item.currencySymbol}${item.maxApplicationFee}`
                                      : ""}{" "}
                                  </div>
                                )}
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>University at a Glance</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`Glance${index}`}
                              >
                                <ul className={styles.university_at_a_glance}>
                                  <li>
                                    <span className={styles.first}>
                                      International Students:{" "}
                                    </span>
                                    <span className={styles.last}>
                                      {item.internationalStudents
                                        ? item.internationalStudents
                                        : "N/A"}
                                    </span>
                                  </li>
                                  <li>
                                    <span className={styles.first}>
                                      Male/Female Ratio:{" "}
                                    </span>
                                    <span className={styles.last}>
                                      {item.maleFemaleRatio
                                        ? item.maleFemaleRatio
                                        : "N/A"}{" "}
                                    </span>
                                  </li>
                                  <li>
                                    <span className={styles.first}>
                                      UG/PG Course Ratio:{" "}
                                    </span>
                                    <span className={styles.last}>
                                      {item.ugPgRatio ? item.ugPgRatio : "N/A"}
                                    </span>
                                  </li>
                                  <li>
                                    <span className={styles.first}>
                                      Faculty/Student Ratio:{" "}
                                    </span>
                                    <span className={styles.last}>
                                      {item.facultyRatio
                                        ? item.facultyRatio
                                        : "N/A"}
                                    </span>
                                  </li>
                                  <li>
                                    <span className={styles.first}>
                                      No. of Campuses:
                                    </span>
                                    <span className={styles.last}>
                                      {" "}
                                      {item.noOfCampus
                                        ? item.noOfCampus
                                        : "N/A"}{" "}
                                    </span>
                                  </li>
                                  <li>
                                    <span className={styles.first}>
                                      Yearly Hostel & Meals Expense:{" "}
                                    </span>
                                    <span className={styles.last}>
                                      {item.yearlyHotelMealExpenseFrom
                                        ? `${
                                            item.currencySymbol
                                          } ${numFormatter(
                                            item.yearlyHotelMealExpenseFrom
                                          )}`
                                        : "N/A"}
                                    </span>
                                  </li>
                                </ul>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>University Highlight</h3>
                        </TableCell>

                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={`${styles.compare_details_row} from_texteditor_wrapper compare`}
                                key={`heighlight${index}`}
                              >
                                {htmlParse(item.highlight)}
                              </TableCell>
                            );
                          })}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default CompareUniversity;
